import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/pages/Layout";
import { HomePage } from "@/pages/HomePage";
import { MetricsPage } from "@/pages/MetricsPage";
import { RankingsPage } from "@/pages/RankingsPage";
import { ScenarioPage } from "@/pages/ScenarioPage";
import { DashboardPage } from "@/pages/DashboardPage";

/**
 * Main router for the entire app:
 * - "/" -> Home or a simple landing if needed
 * - "/metrics" -> Dedicated page
 * - "/rankings" -> Rankings page
 * - "/dashboard" -> Analytics dashboard
 * - "/scenario" -> Scenario builder
 */

export function AppRoutes() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/metrics" element={<MetricsPage />} />
          <Route path="/rankings" element={<RankingsPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/scenario" element={<ScenarioPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}